import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Switch, Alert, Divider } from "antd";

import { req_edit_lrs_spaceInformation } from "../../api";
import storageUtils from "../../utils/storageUtils";

class SpaceModalConfig extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (condition, item) => {
    item.condition = condition;
    //console.log(item);
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  handle_ui_switch_process = (item, field, e) => {
    const value = e === false ? "NO" : "YES";
    switch (field) {
      case "ONLY_SESSIONTIME":
        item.OnlyLendOneSession = value;
        this.api_modify_item("ONESESSIONTIME", item);
        break;
      case "ONLY_PEOPLE":
        item.OnlyLendOnePeople = value;
        this.api_modify_item("ONEUSER", item);
        break;
      case "SITE_MODEL":
        item.IsSiteModel = value;
        this.api_modify_item("SITEMODEL", item);
        break;
      case "NEED_SEND_MAIL":
        item.NeedSendMail = value;
        this.api_modify_item("NEEDMAIL", item);
        break;
      case "NEED_SIGN_INOUT":
        item.NeedSignInOut = value;
        this.api_modify_item("NEEDSIGN", item);
        break;
      case "NEED_CHCEK_THINGS":
        item.NeedCheckThings = value;
        this.api_modify_item("NEEDCHECK", item);
        break;
      case "NEED_FEE":
        item.NeedFee = value;
        this.api_modify_item("NEEDFEE", item);
        break;

      default:
    }
    //console.log(item);
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { space } = this.props;
    const {
      OnlyLendOnePeople,
      OnlyLendOneSession,
      NeedSendMail,
      NeedSignInOut,
      NeedCheckThings,
      NeedFee,
      RoomCode,
      RoomTwName,
    } = this.props.space;
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        <Divider />
        <div className="row">
          <div className="col-md-8">
            <i className="fas fa-cog"></i>啟用座位預約模式
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="採用座位申請"
              unCheckedChildren="採用時段申請"
              defaultChecked={OnlyLendOnePeople === "NO" ? false : true}
              disabled={true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "SITE_MODEL", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>限單日，只能借一個時段
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="單選時段"
              unCheckedChildren="複選時段"
              defaultChecked={OnlyLendOneSession === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "ONLY_SESSIONTIME", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>限單一時段，只能一人借用
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="單人模式"
              unCheckedChildren="多人模式"
              defaultChecked={OnlyLendOnePeople === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "ONLY_PEOPLE", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>寄發審查電子郵件
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="自動寄發"
              unCheckedChildren="停止發信"
              defaultChecked={NeedSendMail === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "NEED_SEND_MAIL", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>需登載進出入紀錄
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="開啟"
              unCheckedChildren="停用"
              defaultChecked={NeedSignInOut === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "NEED_SIGN_INOUT", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>用完後須通知管理者點交
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="開啟"
              unCheckedChildren="停用"
              defaultChecked={NeedCheckThings === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "NEED_CHCEK_THINGS", e)
              }
            />
          </div>
          <div className="col-md-8">
            <i className="fas fa-cog"></i>具收費標準規定
          </div>
          <div className="col-md-4">
            <Switch
              checkedChildren="計費"
              unCheckedChildren="免費"
              defaultChecked={NeedFee === "NO" ? false : true}
              onChange={(e) =>
                this.handle_ui_switch_process(space, "NEED_FEE", e)
              }
            />
          </div>
        </div>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SpaceModalConfig);
